module.exports = __webpack_public_path__ + "ba3570d60157d0312d2b1a0a427411ad.svg";